import Section from 'pages/layouts/Section';

const StaticPageBody = ({children}) => {
  return (
    <Section>
      <div className="grid grid-cols-12">
        <div className="prose lg:prose-xl col-start-0 col-span-12 lg:col-span-8 lg:col-start-3">
          {children}
        </div>
      </div>
    </Section>
  );
};

export default StaticPageBody;
